/*!

=========================================================
* Paper Dashboard React - v1.3.2
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import {useRef, useParams} from "react";
import "../assets/css/extra.css";
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Filler,
  Tooltip,
  LineController,
  BarController,
} from 'chart.js';
import { Chart,Line } from 'react-chartjs-2';
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  Button,
} from "reactstrap";
// core components
import {
  dashboard24HoursPerformanceChart,
  dashboardEmailStatisticsChart,
  dashboardNASDAQChart,
} from "variables/charts.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileLines } from '@fortawesome/free-solid-svg-icons'
import zoomPlugin from 'chartjs-plugin-zoom';
import Hammer, { on } from "hammerjs";
import { AvatarGenerator } from 'random-avatar-generator';
import BasicTable from "../components/TableAndAvgMetrics";
import autocomplete from 'autocompleter';
import BeatLoader from "react-spinners/BeatLoader";
import Table from 'rc-table';
import NotificationAlert from "react-notification-alert";
import CommitDiff from "../components/CommitDiff";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import heatmap from 'highcharts/modules/heatmap.js';
import treemap from 'highcharts/modules/treemap.js';
heatmap(Highcharts);
treemap(Highcharts);



function ProjectHighRisk(props) {
  const generator = new AvatarGenerator();
  const ref = useRef(null);

  const [projectName, setProjectName] = React.useState((new URLSearchParams(window.location.search)).get("name"));
  const [cumulativeDebt, setCumulativeDebt] = React.useState(0);
  const [loc, setLoc] = React.useState(0);
  const [refactorings, setRefactorings] = React.useState(0);
  const [lessDebtDevelopers, setLessDebtDevelopers] = React.useState([]);
  const [moreRefactoringsDevelopers, setMoreRefactoringsDevelopers] = React.useState([]);
  const [dataChart, setDataChart] = React.useState({labels:[], datasets:[]});
  const [tableData, setTableData] = React.useState([]);
  const [heatmapData, setHeatmapData] = React.useState({});
  const [allHeatMapData, setAllHeatMapData] = React.useState([]);
  const [onlyHighRefactoringHeatMapData, setOnlyHighRefactoringHeatMapData] = React.useState([]);
  const [selectedFileFromHeatmap, setSelectedFileFromHeatmap] = React.useState("");
  const [fileMetricsResults, setFileMetricsResults] = React.useState([]);
  const [fileImg, setFileImg] = React.useState();
  const [refactoringAgreement, setRefactoringAgreement] = React.useState("");
  const [refactoringAgreementWaiting, setRefactoringAgreementWaiting] = React.useState("false");
  const [neighborhoodPlotURL, setNeighborhoodPlotURL] = React.useState("");
  const [similarTableColumns, setSimilarTableColumns] =React.useState([
    {
        title: '▢',
        dataIndex: '',
        key: 'd',
        render: (text, record) => (
            <input type="checkbox" id={record.file} onClick={handleCheckBoxTable}/>
        ),
    },
    {
      title: 'Diff',
      dataIndex: '',
      key: 'd2',
      render: (text, record) => (
          <CommitDiff projectName={projectName} file={record.path} />
      ),
    },
    {
      title: 'File',
      dataIndex: 'file',
      key: 'file',
      width: 200,
    },
    {
      title: 'Metrics',
      dataIndex: 'metrics',
      key: 'metrics',
      width: 200,
    },
    {
      title: 'Distance',
      dataIndex: 'distance',
      key: 'distance',
      width: 200,
    }
  ]);
  const [similarTableData, setSimilarTableData] =React.useState([]);
  const [similarTableDataPaths,setSimilarTableDataPaths] = React.useState([]);
  const [checkedTableData, setCheckedTableData] =React.useState([]);
  const handleCheckBoxTable = (e) => {
    if(e.target.checked){
      checkedTableData.push(e.target.id);
    }
    else {
      checkedTableData.pop(e.target.id);
    }
    console.log(checkedTableData);
  }

  const notificationAlert = React.useRef();
  const notify = (message) => {
    var options = {
      place: "tr",
      message: (
        <div>
          <div>
            {message}
          </div>
        </div>
      ),
      type: "warning",
      icon: "nc-icon nc-bell-55",
      autoDismiss: 7,
    };
    notificationAlert.current.notificationAlert(options);
  }


  function onClickCheckBox (key){
    console.log("key: "+key);
  }

  async function handleClickStatus (){
    try {
      const response = await fetch(
        process.env.REACT_APP_API_URL + '/running/refactorings?owner='+process.env.REACT_APP_ORG+'&name='+projectName,{
          method: "GET",
          redirect: "follow",
          headers: {Authorization: `Bearer ${localStorage.getItem("accessToken")}`}
        });
      const result = await response.json();
      if(response.status === 200) {
        var obj = JSON.parse(JSON.stringify(result));
        var now= ((obj.stepNow / obj.stepsTotal)*100).toFixed();
        var total= ((obj.stepsTotal / obj.stepsTotal)*100).toFixed();
        notify("Refactorings analysis is running for this project, please wait " +now+ "%");
      }
      else if (response.status === 404) {
        window.location.reload(false);
      }
      else {
        console.log("API error:", result);
        notify("Refactorings analysis is running for this project, please wait...");
      }
    } catch (error) {
      console.error("Error:", error);
      notify("Refactorings analysis is running for this project, please wait...");
    }
  }

  /**
   * Get projects data from API
   */
  const fetchProjectHeatmapData = async (newcommit) => {
    console.log("Fetching all projects data...");
    try {
      const response = await fetch(
        process.env.REACT_APP_API_URL + '/urgentpy2/project/results?owner='+process.env.REACT_APP_ORG+'&name=' + projectName+'&newcommit='+newcommit,
        {
          method: "GET",
          redirect: "follow",
          headers: {Authorization: `Bearer ${localStorage.getItem("accessToken")}`}
        }
      );
      const result = await response.json();
      if(response.status === 200) {
        var obj = JSON.parse(JSON.stringify(result));
        var results = obj;
        setAllHeatMapData(results);
        var highRefactoringProbability = [];
        for(var i=0; i<results.length; i++){
          if(results[i]['refactoring'] == 'yes'){
            highRefactoringProbability.push(results[i]);
          }
        }
        setOnlyHighRefactoringHeatMapData(highRefactoringProbability);

        setHeatmapData({
          colorAxis: {
              minColor: '#FFFFFF',
              maxColor: 'rgba(255,0,0,1)'
          },
          series: [{
              animation: false,
              type: 'treemap',
              layoutAlgorithm: 'squarified',
              turboThreshold: 3000,
              data: returnValues(highRefactoringProbability),
              tooltip: {
                  pointFormat: '<b>Name:</b> {point.name} <br/> <b>Probability:</b> {point.colorValue}'
              },
              point: {
                events: {
                    click: onClickHeatmap
                }
              }
          }],
          title: {
              text: 'Heatmap of High Refactoring Probability per Class'
          }
        });
      }
      else {
        console.log("Consider Retrain the model");
        console.log("API error:", result);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }


  // Function to extract values from json
  function returnValues(data) {
    var values = []
    for(var i = 0; i < data.length; i++) {
        var pr = null;
        if(data[i]['probability']!=null){
          pr = (Math.round(parseFloat(data[i]['probability']) * 100) / 100);
        }
        values.push({
            'name': data[i]['fileName'],
            'path': data[i]['path'],
            'value': data[i]['loc'],
            'colorValue': pr
        })
    }
    return values
  }



  /**
   * Fetch data from API when component is mounted
   */
  React.useEffect(() => {
    console.log("...ProjectMore component mounted...");
    var name=(new URLSearchParams(window.location.search)).get("name");
    setProjectName(name);

    fetchProjectHeatmapData(false);
  }, []);



  async function onClickHeatmap(){
    console.log("File results...");
    
    setSelectedFileFromHeatmap(this.path+'');
    setRefactoringAgreement("true");
    setFileMetricsResults([]);
    console.log('Name: ' + this.name + ', paht: ' + this.path);

    try {
      const response = await fetch(
        process.env.REACT_APP_API_URL + '/urgentpy2/file/predict?owner='+process.env.REACT_APP_ORG+'&name=' + projectName 
            +"&file="+this.path,
        {
          method: "GET",
          redirect: "follow",
          headers: {Authorization: `Bearer ${localStorage.getItem("accessToken")}`}
        }
      );
      if(response.status === 200) {
        console.log("File results...");
        try {
          const response = await fetch(
            process.env.REACT_APP_API_URL + '/urgentpy2/file/results/more?owner='+process.env.REACT_APP_ORG+'&name=' + projectName 
                +"&file="+this.path,
            {
              method: "GET",
              redirect: "follow",
              headers: {Authorization: `Bearer ${localStorage.getItem("accessToken")}`}
            }
          );
          const result = await response.json();
          if(response.status === 200) {
            var obj = JSON.parse(JSON.stringify(result));
            setFileMetricsResults(obj);
          }
          else {
            console.log("API error");
          }
        } catch (error) {
          console.error("Error:", error);
        }
      
        console.log("File results...");
        try {
          const response = await fetch(
            process.env.REACT_APP_API_URL + '/urgentpy2/file/results/image?owner='+process.env.REACT_APP_ORG+'&name=' + projectName 
                +"&file="+this.path,
            {
              method: "GET",
              redirect: "follow",
              headers: {Authorization: `Bearer ${localStorage.getItem("accessToken")}`}
            }
          );
          if(response.status === 200) {
            const imageBlob = await response.blob();
            const imageObjectURL = URL.createObjectURL(imageBlob);
            setFileImg(imageObjectURL);
          }
          else {
            console.log("API error");
          }
        } catch (error) {
          console.error("Error:", error);
        }
        
      }
      else {
        console.log("API error");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }

  /**
   * Change heatmap data
   */
  function changeShowOnlyHighTD(e) {
    const element = ref.current;
    console.log(element.checked);
    if(element.checked) {
      setHeatmapData({
        colorAxis: {
            minColor: '#FFFFFF',
            maxColor: 'rgba(255,0,0,1)'
        },
        series: [{
            animation: false,
            type: 'treemap',
            layoutAlgorithm: 'squarified',
            turboThreshold: 3500,
            data: returnValues(allHeatMapData),
            tooltip: {
                pointFormat: '<b>Name:</b> {point.name} <b></b>'
            },
            point: {
              events: {
                  click: onClickHeatmap
              }
            }
        }],
        title: {
            text: 'Heatmap of High Refactoring Probability per Class'
        }
      });
    }
    else {
      setHeatmapData({
        colorAxis: {
            minColor: '#FFFFFF',
            maxColor: 'rgba(255,0,0,1)'
        },
        series: [{
            animation: false,
            type: 'treemap',
            layoutAlgorithm: 'squarified',
            turboThreshold: 3000,
            data: returnValues(onlyHighRefactoringHeatMapData),
            tooltip: {
                pointFormat: '<b>Name:</b> {point.name} <b></b>'
            },
            point: {
              events: {
                  click: onClickHeatmap
              }
            }
        }],
        title: {
            text: 'Heatmap of High Refactoring Probability per Class'
        }
      });
    }
  }

  /**
   * Train Model API call
   */
  async function onClickTrainModel(e) {
    console.log("Train Model API call...");
    try {
      const response = await fetch(
        process.env.REACT_APP_API_URL + '/urgentpy2/train?owner='+process.env.REACT_APP_ORG+'&name=' + projectName,
        {
          method: "GET",
          redirect: "follow",
          headers: {Authorization: `Bearer ${localStorage.getItem("accessToken")}`}
        }
      );
      if(response.status === 200) {
        console.log("Train finished!");
        fetchProjectHeatmapData();
      }
      else {
        console.log("API error");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }

  function handelClickRefactoringAgree(){

  }

  async function handelClickRefactoringDisagree(){
    console.log("Calculate neighborhood...");
    setRefactoringAgreementWaiting("true");
    setRefactoringAgreement("false");
    try {
      const response = await fetch(process.env.REACT_APP_API_URL + '/urgentpy2/file/neighborhood/calculate?owner='+process.env.REACT_APP_ORG+'&name=' + projectName +'&file='+selectedFileFromHeatmap,
          {
            method: "GET",
            redirect: "follow",
            headers: {Authorization: `Bearer ${localStorage.getItem("accessToken")}`}
          }
      );
      const result = await response.json();
      if(response.status === 200) {
        var obj = JSON.parse(JSON.stringify(result));
        var results = [];
        var paths = [];
        for(var i=0; i<obj.length; i++){
          paths.push(obj[i].split(";")[0]);
          var fileName= obj[i].split("/")[obj[i].split("/").length -1]
          if (fileName.split(";").length>1){ 
            if(fileName.split(";")[2]=="1")
              results.push({path: obj[i].split(";")[0], file: fileName.split(";")[0], metrics: fileName.split(";")[1], distance: Math.round(parseFloat(fileName.split(";")[3])*10)/10});
          }
          else
            results.push({path: obj[i].split(";")[0], file: fileName.split(";")[0], metrics: "", distance: ""});
        }
        setSimilarTableData(results);
        setSimilarTableDataPaths(paths);
        setNeighborhoodPlotURL(process.env.REACT_APP_API_URL+"/urgentpy2/file/neighborhood/plot?owner="+process.env.REACT_APP_ORG+'&name='+projectName+"&file="+selectedFileFromHeatmap);
      }
      else {
        console.log("API error");
      }
    } catch (error) {
      console.error("Error:", error);
    }
    setRefactoringAgreementWaiting("false");
  }

  async function onClickSaveExpertsOpinion(){
    if(checkedTableData.length>0){
      var checkedTableDataTMP = [];
      for(var i=0; i<checkedTableData.length; i++){
        for(var k=0; k<similarTableDataPaths.length; k++){
          if(similarTableDataPaths[k].endsWith(checkedTableData[i])){
            checkedTableDataTMP.push(similarTableDataPaths[k]);
            break;
          }
        }
      }
      console.log(checkedTableDataTMP);
      console.log("Save Opinion...");
      try {
        const response = await fetch(process.env.REACT_APP_API_URL + '/urgentpy2/newopinion?owner='+process.env.REACT_APP_ORG+'&name='+projectName, {
          method: "POST",
          redirect: "follow",
          headers: {
            'Accept': 'application/json, text/plain',
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': `Bearer ${localStorage.getItem("accessToken")}`
          },
          body: JSON.stringify(checkedTableDataTMP),
        });
        const result = await response.json();
        if(response.status === 200) {

        }
        else {
          console.log("API error:", result);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
  }


  return (
    <>
      <div className="content">
        <NotificationAlert ref={notificationAlert} />
        <CardTitle tag="h5">{projectName}</CardTitle>
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <div style={{display:"flex", justifyContent:"space-between"}}>
                  <CardTitle tag="h5" style={{display:"flex", alignContent:"center"}}>
                    Refactoring Urgency
                    <i style={{marginLeft:"10px", marginTop:"auto", marginBottom:"auto", cursor: "pointer"}} onClick={()=>fetchProjectHeatmapData(true)} className="nc-icon nc-refresh-69" title="Calculate on last commit" />
                  </CardTitle>
                  {allHeatMapData.length!=0 ? 
                    <div style={{display:"flex", marginBottom:"auto", marginTop:"auto"}}>
                      <label class="switch" style={{margin:"auto"}} onChange={changeShowOnlyHighTD}>
                        <input ref={ref} id="switchTD" type="checkbox"/>
                        <span class="slider round"></span>
                      </label>
                      <span style={{margin:"auto", marginLeft:"5px"}}>Show all files</span>
                    </div>
                    :
                    <></>}
                </div>
              </CardHeader>
              <CardBody>
                {allHeatMapData.length!=0 ? 
                  <div>
                    <Row>
                      <Col md="12">
                        <HighchartsReact highcharts={Highcharts} options={heatmapData} immutable = {true} />
                      </Col>
                    </Row>
                    {selectedFileFromHeatmap == "" ? 
                        <span>Select a file..</span>
                      :
                      <div>
                        {fileMetricsResults.length==0 ?
                        <div>
                          <BeatLoader color={"#119f50"} />
                        </div>
                         : 
                        <>
                          <Row>
                            <div style={{padding:"15px", overflowWrap:"anywhere"}}>
                              <p>Fille: {selectedFileFromHeatmap}</p>
                            </div>
                            <Col md="12">
                              <Row>
                                <Col md="3" xl="3">
                                  <Row>
                                    {fileMetricsResults.map((metric) => (
                                      <Col md="12">
                                        <Card>
                                          <CardHeader >
                                            <CardTitle tag="h5">{metric.metric}</CardTitle>
                                          </CardHeader>
                                          <CardBody>
                                            {(metric.value=="yes" || metric.value=="no")? 
                                              <>{metric.value=="yes" ? <>Recommended</> :<>No Need</>}</>
                                            :
                                              <>{(Number(metric.value)*100).toLocaleString(undefined, {maximumFractionDigits:2})} %</>
                                            }
                                          </CardBody>
                                        </Card>
                                      </Col>
                                    ))}
                                  </Row>
                                </Col>
                                <Col md="9" lg="9" xl="5">
                                  <Row>
                                    <Col md="12">
                                      <Card>
                                        <CardHeader >
                                          <CardTitle tag="h5">Reason to Refactor</CardTitle>
                                        </CardHeader>
                                        <CardBody style={{margin:"auto"}}>
                                          <img src={fileImg} alt="all metrics diagram"></img>
                                        </CardBody>
                                      </Card>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col md="12" lg="12" xl="4">
                                  <Card>
                                    <CardHeader >
                                      <CardTitle style={{textAlign:"center"}} tag="h5">Do you agree with this refactoring?</CardTitle>
                                    </CardHeader>
                                    <CardBody style={{textAlign:"center", paddingTop:"0px"}}>
                                      <Button
                                        className="btn-round"
                                        color="primary"
                                        type="submit"
                                        style={{margin:"4px", padding:"4px", backgroundColor: "transparent"}}
                                        title="More"
                                        onClick={handelClickRefactoringAgree}>
                                        <img src={require("assets/img/accept.png")} style={{width:"50px"}}/>
                                      </Button>
                                      <Button
                                        className="btn-round"
                                        color="primary"
                                        type="submit"
                                        style={{margin:"4px", padding:"4px", backgroundColor: "transparent"}}
                                        title="More"
                                        onClick={handelClickRefactoringDisagree}>
                                        <img src={require("assets/img/reject.png")} style={{width:"50px"}}/>
                                      </Button>
                                    </CardBody>
                                  </Card>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </>
                      }
                      </div>
                    }
                  </div>
                  : <div style={{display:"flex", justifyContent:"center", flexDirection: "column", alignItems: "center"}}>
                      <BeatLoader color={"#119f50"} />
                      <Button className="btn-round" color="primary" onClick={handleClickStatus}>Status</Button>
                    </div>}
              </CardBody>
            </Card>
          </Col>
        </Row>
        {
          refactoringAgreement=="false" ? 
            <Row>
              <Col md="12">
                <Card>
                  <CardHeader>
                      <CardTitle tag="h5">Expert's Option</CardTitle>
                  </CardHeader>
                  <CardBody>
                    {refactoringAgreementWaiting=="false" ?
                    <>
                    <Row>
                      <Col lg="7" md="8">
                        <Card>
                          <CardHeader >
                            <CardTitle style={{textAlign:"center"}} tag="h5">Similar Past Cases of Performed Refactorings.
                                    <br/> Please check those that you disagree with!</CardTitle>
                          </CardHeader>
                          <CardBody style={{textAlign:"center", paddingTop:"0px"}}>
                            <Table columns={similarTableColumns} data={similarTableData} />
                          </CardBody>
                        </Card>
                      </Col>
                      <Col lg="5" md="4">
                        <Row>
                          <Col md="12">
                            <Card>
                              <CardHeader>
                                <CardTitle tag="h5">Neighborhood</CardTitle>
                              </CardHeader>
                              <CardBody>
                                <div>
                                  <iframe
                                    src= {neighborhoodPlotURL}
                                    title="External HTML"
                                    width="100%"
                                    height="500px"
                                    frameBorder="0"
                                  />
                                </div>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row style={{justifyContent:"center"}}>
                      <Col md="4">
                        <Card>
                          <CardHeader >
                            <CardTitle style={{textAlign:"center"}} tag="h5">Save expert opinion</CardTitle>
                          </CardHeader>
                          <CardBody style={{textAlign:"center", paddingTop:"0px"}}>
                            <Button
                              className="btn-round"
                              color="primary"
                              type="submit"
                              style={{margin:"5px", padding:"5px", backgroundColor: "transparent"}}
                              onClick={onClickSaveExpertsOpinion}
                              >
                              <img src={require("assets/img/Save-PNG.png")} style={{width:"60px"}} />
                            </Button>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                    </>
                    :
                    <Row style={{justifyContent:"center"}}>
                      <BeatLoader color={"#119f50"} />
                    </Row>
                    }
                  </CardBody>
                </Card>
              </Col>
            </Row>
          :
            <></>
        }
        <Row style={{justifyContent:"center"}}>
          <Col md="4">
            <Card>
              <CardHeader >
                <CardTitle style={{textAlign:"center"}} tag="h5">Retrain Model</CardTitle>
              </CardHeader>
              <CardBody style={{textAlign:"center", paddingTop:"0px"}}>
                <i onClick={onClickTrainModel} className="nc-icon nc-refresh-69" />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default ProjectHighRisk;
